import { memo } from 'react';

import STYLES from './ImageGalleryMap.module.scss';

import { HASH_FULL_MAP } from '@shared/constants/hash-routes';
import RouteLink from '@shared/ui/common/RouteLink';
import StaticMaps from '@shared/ui/components/StaticMaps';

// always return true to avoid re-rendering map component
const propsAreEqual = () => true;

const ImageGalleryMap = () => (
  <RouteLink
    href={HASH_FULL_MAP}
    render={(routeLinkOnClick: Function) => (
      <button
        type="button"
        aria-label="map container"
        onClick={(e) => {
          routeLinkOnClick(e);
        }}
        className={STYLES.ImageGalleryMap__mapContainer}
      >
        <div className={STYLES.ImageGalleryMap__map}>
          <StaticMaps small />
        </div>
      </button>
    )}
  />
);

export default memo(ImageGalleryMap, propsAreEqual);
